export const API_HOST = "https://faktoring-api.g1net.pl";
export const API_PATH = "";



// WEBPACK FOOTER //
// ./src/config/_entrypoint.js